import EmptyScannerState from './ScannedItemsList/EmptyScannerState';
import ListHeader from './ScannedItemsList/ListHeader';
import { ScannedCheckpointItem } from '../../models';
import ScannedItemCard from './ScannedItemCard';

interface ScannedItemsListProps {
  items: ScannedCheckpointItem[];
  onRemoveItem: (number: string) => void;
  onClearAll: () => void;
}

const ScannedItemsList = ({ items, onRemoveItem, onClearAll }: ScannedItemsListProps) => {
  return (
    <div className='bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-8'>
      <ListHeader count={items.length} onClearAll={onClearAll} />
      <div className='flex flex-col gap-3 max-h-[600px] overflow-y-auto px-1'>
        {items.length === 0 ? (
          <EmptyScannerState />
        ) : (
          items.map((item, index) => (
            <ScannedItemCard
              key={`${item.number}-${item.scannedDt}`}
              item={item}
              index={items.length - index}
              onRemove={onRemoveItem}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ScannedItemsList;
